import { WidgetsPartyDetailMain } from '@/widgets/party-detail';

export const PagesPartyDetailMain = () => <WidgetsPartyDetailMain />;
